var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-width-1-4@m"},[_c('button',{staticClass:"uk-button uk-button-primary uk-align-right",on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.$t('frontend-mtg.area_riservata.ordini.export')))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c979560a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/OrdersExport.vue
// module id = 5vJX
// module chunks = 0